import { nextApiRoutesClient } from 'modules/common/http/nextApiRoutesClient'

export interface PostChangePasswordRequestProps {
  email: string
}
export const postChangePasswordRequest = async ({
  email,
}: PostChangePasswordRequestProps) => {
  const { data } = await nextApiRoutesClient.post<void>(
    '/api/auth/requestChangePasswordEmail',
    { email }
  )

  return data
}
